import React from 'react';

const UserIcon = () => (
    <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8.5 9C9.88071 9 11 7.88071 11 6.5C11 5.11929 9.88071 4 8.5 4C7.11929 4 6 5.11929 6 6.5C6 7.88071 7.11929 9 8.5 9Z"
            stroke="#767676"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.25732 14.5C4.47896 13.8731 4.83888 13.2971 5.31799 12.818C6.1619 11.9741 7.30649 11.5 8.49997 11.5C9.69344 11.5 10.838 11.9741 11.6819 12.818C12.1329 13.2689 12.4782 13.8057 12.7021 14.3899"
            stroke="#767676"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle
            cx="8.5"
            cy="8.5"
            r="7.5"
            stroke="#767676"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default UserIcon;
